import React, { type FC, type ReactNode } from "react";

import { type VariantProp, cv } from "~/tools/class-variance";

const variants = cv("flex w-full flex-col items-center justify-center text-center", {
	variants: {
		layout: {
			plain: "p-4",
			compact: "rounded-lg bg-white p-8",
			full: "p-8 pt-12",
		},
	},
});

export interface MessagePaneProps {
	title?: ReactNode;
	message: ReactNode;
	layout: VariantProp<typeof variants, "layout">;
}

export const EmptyStateWidget: FC<MessagePaneProps> = ({ title, message, layout }) => (
	<div className={variants({ layout, className: null })}>
		{title && <header className="mb-3 font-medium text-grey-800 text-sm">{title}</header>}
		<div className="text-13/[21px] text-grey-600">{message}</div>
	</div>
);
